import React, { useState } from 'react'
import { ContactFormWrapper } from './Styled'
import { useForm } from "react-hook-form"
import { Box, LabelStyled, SpanStyled } from '../../../ui/Elements'
import { ContactButton } from '../../../ui/CustomElements'
import { ArrowBtn } from '../../../ui/AllImages'
import { Spinner } from "react-bootstrap";
import { useTranslation } from 'react-i18next'
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row } from 'react-bootstrap'
const ContactForm = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [phone, setPhone] = useState('');
    const { t, i18n } = useTranslation();
    
   const { register, handleSubmit, reset, setValue, clearErrors, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: { name:'', subject:'', email:'', phone:'', message:'', language: i18n.language }
    });
    const getApi = async (data) => {
        try {
            setIsLoading(true);
            data.language = i18n.language;
            const response = await axios.post("https://soola.sa/api/public/api/contact-us", data, {
                headers: {
                    "X-Language-ID": i18n.language == "en" ? 2 : 1,
                    
                    
                }
            });
            if (response.status === 200) {
                reset({
                    name: '',
                    // subject: '',
                    email: '',
                    phone: '',
                    message: '',
                    language: '',
                });
                setPhone('');
                // toast.success("Your submission was successful.", { autoClose: 3000 });
                toast.success(t('submission'), {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    // className: 'message'
                })
                setIsLoading(false);
            } else {
                toast.error(t('submission_fail'), {
                    position: "bottom-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                reset({
                    name: '',
                    // subject: '',
                    email: '',
                    phone: '',
                    message: '',
                    language: '',
                });
                setPhone('');
                setIsLoading(false);
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            // alert("Submission has failed.");
            toast.error(t('submission_fail'), {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            reset({
                name: '',
                // subject: '',
                email: '',
                phone: '',
                message: '',
                language: '',
            });
            setPhone('');
            setIsLoading(false);
        }
    }
   
    const handlePhoneChange = (e) => {
        
        const cleaned = e.target.value.replace(/[^\d+]/g, "");
        setPhone(cleaned);

        
        setValue("phone", cleaned, { shouldValidate: true, shouldDirty: true });

       
        if (cleaned && errors.phone) clearErrors("phone");
    };

    const onSubmit = async (data) => {
        console.log(data);
        getApi(data);
    };

    return (
        <>

            <ContactFormWrapper>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row className='mb-3'>
                        <Col md={12} className='py-2 inputCol field-box'>
                            <LabelStyled >{t('Name')}</LabelStyled>
                            <input className='input-field' placeholder={t('NameP')}  {...register("name", { required: true })} aria-invalid={errors.name ? "true" : "false"} />
                            {errors.name?.type === "required" && (<p className='error-message' role="alert">{t('name_error')}</p>)}
                        </Col>
                        {/* <Col md={12} lg={6} className='py-2 inputCol field-box'>
                            <LabelStyled >{t('Subject')}</LabelStyled>
                            <input className='input-field' placeholder={t('subjectPlaceholder')}  {...register("subject", { required: true })} aria-invalid={errors.subject ? "true" : "false"} />
                            {errors.subject?.type === "required" && (<p className='error-message' role="alert">{t('subject_error')}</p>)}
                        </Col> */}
                        <Col md={12} className='py-2 inputCol field-box'>
                            <LabelStyled>{t('Email')}</LabelStyled>
                            <input className='input-field' placeholder={t('EmailP')} type='email'{...register("email", { required: true })} aria-invalid={errors.email ? "true" : "false"} />
                            {errors.email && <p className='error-message' role="alert">{t('email_error')}</p>}
                        </Col>
                        <Col md={12} className='py-2 inputCol field-box'>
                            <LabelStyled >{t('Phone')}</LabelStyled>
                            <input className='input-field' placeholder={t('PhoneP')} type='text' value={phone} {...register("phone", { required: true })} aria-invalid={errors.phone ? "true" : "false"} onChange={handlePhoneChange} />
                            {errors.phone && <p className='error-message' role="alert">{t('phone_error')}</p>}
                        </Col>
                        
                        
                        <Col md={12} className='py-2 inputCol field-box'>
                            <LabelStyled >{t('Message')}</LabelStyled>
                            <textarea className='input-field' placeholder={t('messagePlaceholder')} cols="30" rows="5" {...register("message", { required: true })} aria-invalid={errors.message ? "true" : "false"} />
                            {errors.message && <p className='error-message' role="alert">{t('message_error')}</p>}
                        </Col>
                    </Row>
                    <Box className='d-flex justify-content-end my-3 contact-btn'>
                        
                        <SpanStyled className='d-flex align-items-center gap-2 pos-rel'>
                            {isLoading ? <p className='loading-btn'><span className='spinner'><Spinner className="custom-spinner" /></span></p> : null}
                            <ContactButton icon={ArrowBtn} label={t('Submit')} type="submit" />
                        </SpanStyled>
                    </Box>
                </form>
                <ToastContainer />

            </ContactFormWrapper >
        </>
    )
}

export default ContactForm